import React from 'react';
import {StlViewer} from "react-stl-viewer";

function STLViewerComponent({ url }) {
    const style = {
        width: '100%',
        height: '70vh',
    }
    return      <div
        className={`md:relative lg:absolute right-[10%] top-0`}
    > <StlViewer
        style={style}
        modelProps={{
            positionX: 150,
            positionY: 150,
            ref: {
                current: '[ModelRef]'
            },
            rotationX:-300,
            rotationY: 0,
            rotationZ:0,
            scale: 1
        }}
        orbitControls
        // shadows
        url={url}
    />
    </div>
}

export default STLViewerComponent;
